import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { setToastData } from "../../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { ErrorMessage, Field, Form, Formik } from "formik";
import moment from "moment";

const FillSurvey = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { accessToken, userData } = useSelector(state => state.user);
    const [surveyData, setSurveyData] = useState({});
    const [surveyId, setSurveyId] = useState(0);
    const normalizeOption = (value) => String(value || "").trim();
    useEffect(() => {
        if (!location.state?.survey_id || location.state?.survey_id < 1) {
            navigate('/survey');
        }
        else {
            setSurveyId(location.state?.survey_id);
            dispatch(setPageTitle('Fill Survey'));

        }
    }, [dispatch, location.state?.survey_id, navigate]);
    useEffect(() => {
        if (surveyId > 0) {
            getSurveyData();
        }
    }, [surveyId])
    const getSurveyData = () => {
        dispatch(setMainLoading(true));
        PostAxios(`survey/survey-details-with-response`, { survey_id: surveyId }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setSurveyData({ ...data.data });
                }
                else {
                    dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const initialValues = (surveyData?.form_fields || []).reduce((values, question) => {
        const fieldKey = String(question.id);
        if (question.type === 'checkbox') {
            values[fieldKey] = question?.value ? String(question.value).split(",").map((option) => normalizeOption(option)).filter(Boolean) : [];
        }
        else {
            values[fieldKey] = question?.value || "";
        }
        return values;
    }, {});
    const validate = (values) => {
        const errors = {};

        surveyData?.form_fields.forEach((question) => {
            const fieldKey = String(question.id);
            const value = values[fieldKey];
            const isEmptyCheckbox = question.type === "checkbox" && (!Array.isArray(value) || value.length === 0);
            const isEmptyValue = value === "" || value === null || typeof value === "undefined";
            if (parseInt(question.required) === 1 && (isEmptyCheckbox || isEmptyValue)) {
                errors[fieldKey] = `${question.label} is required`;
            }
        });

        return errors;
    };
    const handleSubmit = (values, { setSubmitting }) => {
        const formattedValues = Object.entries(values).map(([field_id, answer]) => ({
            field_id,
            answer: Array.isArray(answer) ? answer.join(",") : answer,
        }));
        setSubmitting(true);
        dispatch(setMainLoading(true));
        PostAxios(`survey/save-survey-response`, {
            survey_id: surveyId,
            field_responses: formattedValues,
        }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    dispatch(setToastData({ message: data.message, isHtml: true, type: 'success', showCloseBtn: true }));
                    getSurveyData();
                }
                else {
                    dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
                setSubmitting(false);
            })
    };
    const MyCheckbox = ({ field, form, label, value, ...rest }) => {
        const { name } = field;
        const currentValue = Array.isArray(field.value) ? field.value : [];

        const isChecked = currentValue.includes(value);

        const handleChange = () => {
            const newValue = isChecked
                ? currentValue.filter((v) => v !== value)
                : [...currentValue, value];

            form.setFieldValue(name, newValue);
        };

        return (
            <label className="container-checkbox">
                <input
                    type="checkbox"
                    name={name}
                    value={value}
                    checked={isChecked}
                    onChange={handleChange}
                    {...rest}
                />
                <span className="checkmark"></span>
                {label}
            </label>
        );
    };
    if (typeof surveyData.title !== "undefined") {
        return <div className="main-form-sec" style={{ width: "100%", maxWidth: "600px", marginLeft: "auto", marginRight: "auto" }}>
            <h3 className="text-center">{surveyData.title}</h3>
            <p className="my-3">{surveyData.description}</p>
            <div className="divider"></div>
            <Formik
                initialValues={initialValues}
                validate={validate}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ errors, touched, isSubmitting }) => (
                    <Form>
                        <div className="form-sec">
                            {surveyData?.form_fields.map((question) => (
                                <div key={`question-wrapper-${question.id}`} className={`form-field-group w-100 ${(errors[String(question.id)] && touched[String(question.id)]) ? 'error-input' : ''}`}>
                                    <div className="w-100 mb-1">
                                        <label>{question.label} {parseInt(question.required) === 1 && <span className="text-danger">*</span>}</label>
                                    </div>

                                    {question.type === "text" && (
                                        <div className="w-100">
                                            <Field type="text" className="form-input mb-1" name={String(question.id)} disabled={surveyData?.is_submitted} />
                                            <ErrorMessage name={String(question.id)} component="span" className="error-label" />
                                        </div>
                                    )}
                                    {question.type === "textarea" && (
                                        <div className="w-100">
                                            <Field as="textarea" className="form-input form-textarea mb-1" name={String(question.id)} rows={5} disabled={surveyData?.is_submitted} />
                                            <ErrorMessage name={String(question.id)} component="span" className="error-label" />
                                        </div>
                                    )}
                                    {(question.type === "radio") &&
                                        <Field name={String(question.id)} as="select" className="select-input mb-1" disabled={surveyData?.is_submitted}>
                                            <option value="">Choose</option>
                                            {
                                                question.options.split(",").map((option, index) => (
                                                    <option value={option} key={`${question.id}-${index}`}>{option}</option>
                                                ))
                                            }
                                        </Field>
                                    }
                                    {(question.type === "checkbox") &&
                                        question.options.split(",").map((option, index) => {
                                            const normalizedOption = normalizeOption(option);
                                            return (
                                            <div key={`question-id-${question.id}-${index}`}>
                                                <Field
                                                    key={`question-${question.id}-${index}`}
                                                    name={String(question.id)}
                                                    component={MyCheckbox}
                                                    value={normalizedOption}
                                                    label={normalizedOption}
                                                    disabled={surveyData?.is_submitted}

                                                />
                                            </div>
                                        )})}

                                </div>
                            ))}
                            {
                                (userData.role_slug !== "super_admin" && !surveyData?.is_submitted) &&
                                <div className="btm-right-btn justify-content-center my-3">
                                    <button className="btn-blue btn" type="submit" disabled={isSubmitting}>Submit</button>
                                </div>
                            }
                            {
                                surveyData?.is_submitted &&
                                <div className="btm-right-btn justify-content-center my-3">
                                    <span className="text-success">Submitted at {moment(surveyData?.submitted_at).format("DD-MM-YYYY hh:mm A")}</span>
                                </div>
                            }
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    }
    return null;
}

export default FillSurvey